module.exports = __webpack_public_path__ + "static/map-cabc8158030edadff81fbdc0314cb85b.jpg";